import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import analytics from '../utility/analytics';
import { PrimaryButton, PrimaryOutlineButton } from '../buttons';
import getPdf from '../helpers/getPdf';
import { Input } from '../inputs';
import { Heading, Loader } from '../components';
import { sync } from '../wizard/actions';
import { ButtonContainer, LeadFormContainer, SuccessMessage } from './';

const PdfFormInput = styled.div({
  margin: '24px 0',
  '> div:not(:last-of-type)': {
    marginBottom: 16,
  },
});

const PdfFormRedux = ({
  requireEmail, requirePhonenumber, onRequestClose, formIsLoading, setFormIsLoading }) => {
  const dispatch = useDispatch();
  const { app, input } = useSelector(state => state);
  const [showSucces, setShowSuccess] = useState(false);
  const [errors, setErrors] = useState({});
  const requireForm = requireEmail || requirePhonenumber;

  const handleDownloadPdf = useCallback(async e => {
    if (e) e.preventDefault();
    setErrors({})
    setFormIsLoading(true);
    const downloadUrl = `/${app}/${requireForm ? 'pdf-lead' : 'pdf'}`;
    const errors = await getPdf(downloadUrl, input, () => analytics.send('Download', 'PDF'), `/${app}/pdf`);
    setFormIsLoading(false);
    if (requireForm) {
      setErrors({ ...errors });
    }
    setShowSuccess(!errors);
  }, [app, input, setShowSuccess, setErrors, setFormIsLoading, requireForm]);

  useEffect(() => {
    if (!requireForm) handleDownloadPdf()
  }, [handleDownloadPdf, requireForm]);

  return (
    <>
      {showSucces ? (
        <SuccessMessage onRequestClose={onRequestClose} showPdfSucces={showSucces} />
      ) : (
        <LeadFormContainer>
          <form onSubmit={handleDownloadPdf}>
            <Heading>Download rapport</Heading>
            {!requireForm ? (
              <p>Het persoonlijke rapport wordt nu gedownload</p>
            ) : (
              <>
                <p>Vul de onderstaande gegevens in om een persoonlijk rapport te ontvangen.</p>
                <PdfFormInput>
                  {requireEmail && (
                    <Input
                      placeholder="E-mailadres"
                      name="email"
                      value={input['email']}
                      onChange={sync(dispatch)('email')}
                      errors={errors['email']}
                      autoFocus={true}
                    />
                  )}
                  {requirePhonenumber && (
                    <Input
                      placeholder="Telefoonnummer"
                      name="phone_number"
                      value={input['phone_number']}
                      onChange={sync(dispatch)('phone_number')}
                      errors={errors['phone_number']}
                      autoFocus={!requireEmail}
                    />
                  )}
                </PdfFormInput>
              </>
            )}
            <ButtonContainer>
              <PrimaryOutlineButton onClick={() => onRequestClose()} disabled={formIsLoading}>
                Annuleren
              </PrimaryOutlineButton>
              <PrimaryButton type="submit" disabled={formIsLoading}>
                {formIsLoading ? <Loader css={{ margin: 0 }} invertedColor /> : 'Download'}
              </PrimaryButton>
            </ButtonContainer>
          </form>
        </LeadFormContainer>
      )}
    </>
  );
};

PdfFormRedux.propTypes = {
  requireEmail: PropTypes.bool,
  requirePhonenumber: PropTypes.bool,
  onRequestClose: PropTypes.func.isRequired,
  formIsLoading: PropTypes.bool,
  setFormIsLoading: PropTypes.func,
};

PdfFormRedux.defaultProps = {
  requireEmail: false,
  requirePhonenumber: false,
  formIsLoading: false,
  setFormIsLoading: () => {},
};

export default PdfFormRedux;
